module.exports = __webpack_public_path__ + "img/Tessellate01.d622e345.jpg";